module.exports = __webpack_public_path__ + "static/media/relevance_ai.3f94a422.png";